// =============================================================================
// SELF-TEST DEFINITIONS
// =============================================================================
//
// Eenvoudige zelftests als data-input.
// Geen feedback, geen conclusies, geen labels zoals "zwak" of "sterk".
//
// =============================================================================

/**
 * Rolvoorkeuren (geen oordeel, alleen voorkeur)
 */
export type RolePreference = 'doer' | 'thinker' | 'connector' | 'leader';

export const ROLE_LABELS: Record<RolePreference, string> = {
  doer: 'Doener',
  thinker: 'Denker',
  connector: 'Verbinder',
  leader: 'Leider',
};

export const ROLE_DESCRIPTIONS: Record<RolePreference, string> = {
  doer: 'Je pakt graag direct aan en brengt zaken in de praktijk.',
  thinker: 'Je denkt graag vooruit en analyseert eerst voordat je handelt.',
  connector: 'Je verbindt graag mensen en ideeën met elkaar.',
  leader: 'Je neemt graag de leiding en stuurt processen aan.',
};

/**
 * Leerstijlen (VARK model: Visual, Auditory, Reading/Writing, Kinesthetic)
 */
export type LearningStyle = 'visual' | 'auditory' | 'reading' | 'kinesthetic';

export const LEARNING_STYLE_LABELS: Record<LearningStyle, string> = {
  visual: 'Visueel',
  auditory: 'Auditief',
  reading: 'Lezen/Schrijven',
  kinesthetic: 'Praktisch doen',
};

export const LEARNING_STYLE_DESCRIPTIONS: Record<LearningStyle, string> = {
  visual: 'Je leert het beste door te kijken: video\'s, diagrammen, schema\'s.',
  auditory: 'Je leert het beste door te luisteren: podcasts, gesprekken, uitleg.',
  reading: 'Je leert het beste door te lezen en schrijven: artikelen, boeken, notities.',
  kinesthetic: 'Je leert het beste door te doen: oefenen, experimenteren, uitproberen.',
};

/**
 * Kennisniveaus per domein (neutraal, geen "slecht")
 */
export type KnowledgeLevel = 'new' | 'learning' | 'familiar' | 'experienced';

export const KNOWLEDGE_LEVEL_LABELS: Record<KnowledgeLevel, string> = {
  new: 'Nieuw voor mij',
  learning: 'Aan het leren',
  familiar: 'Bekend mee',
  experienced: 'Ervaring mee',
};

/**
 * Domeinen (7 uit Capability Assessment)
 */
export type KnowledgeDomain =
  | 'strategy'
  | 'marketing'
  | 'sales'
  | 'product'
  | 'operations'
  | 'finance'
  | 'team';

export const DOMAIN_LABELS: Record<KnowledgeDomain, string> = {
  strategy: 'Strategie & Richting',
  marketing: 'Marketing & Zichtbaarheid',
  sales: 'Sales & Conversie',
  product: 'Product / Dienst',
  operations: 'Operatie & Systemen',
  finance: 'Financiën',
  team: 'Team & Capaciteit',
};

/**
 * Self-test results (data only, no interpretation)
 */
export interface SelfTestResults {
  rolePreference?: RolePreference;
  learningStyle?: LearningStyle; // Backward compatibility - deprecated, use learningStyles instead
  learningStyles?: LearningStyle[]; // Multiple learning styles supported
  knowledgeLevels: Record<KnowledgeDomain, KnowledgeLevel>;
  completedAt: number;
}
